import { createContext, useContext } from 'react';

import { observer } from 'mobx-react-lite';

const context = createContext();

/** @param {{ children: import('react').ReactNode; store: object }} props */
const StoreProvider = ({ children, store }) => {
  let ctx = {
    t: store.i18n.t,
    lang: store.i18n.lang,
    setLanguage: store.i18n.setLanguage,
    theme: store.theme,
    companies: store.companies,
    switchCompany: store.switchCompany,
    router: store.router,
  };

  if (store.current) {
    ctx.current = store.current;
    ctx.api = store.current.api;
    ctx.userStore = store.current.users;
    ctx.jobStore = store.current.jobs;
    ctx.applicationStore = store.current.applications;
    ctx.notificationStore = store.current.notifications;
    ctx.companyIntegrationStore = store.current.integrations;
    ctx.templateStore = store.current.templates;
    ctx.uiSettings = store.current.uiSettings;
    ctx.jobboardStore = store.current.jobboards;
  }
  return <context.Provider value={ctx}>{children}</context.Provider>;
};

export const Provider = observer(StoreProvider);

export const useStore = () => useContext(context);
